import store, { modulesName } from '@/store';

import langTypes from '@/utils/constants/lang.js';
import {
  isAdminRole,
  isApplicantRole,
  isInvestigatorRole,
  isSupervisorRole,
} from '@/utils/rolePolicy.js';

export const userMixin = {
  computed: {
    userAuthenticated() {
      return store.getters[`${modulesName.userModuleName}/isLoggedIn`];
    },
    userId() {
      return store.getters[`${modulesName.userModuleName}/userId`];
    },
    userRole() {
      return store.getters[`${modulesName.userModuleName}/role`];
    },
    isUserRoleApplicant() {
      return isApplicantRole(store.getters[`${modulesName.userModuleName}/role`]);
    },
    isUserRoleSupervisor() {
      return isSupervisorRole(
        store.getters[`${modulesName.userModuleName}/role`]
      );
    },
    isUserRoleInvestigator() {
      return isInvestigatorRole(
        store.getters[`${modulesName.userModuleName}/role`]
      );
    },
    isUserRoleAdmin() {
      return isAdminRole(store.getters[`${modulesName.userModuleName}/role`]);
    },
    userFullName() {
      return store.getters[`${modulesName.userModuleName}/fullName`];
    },
    userMainCompany() {
      return store.getters[`${modulesName.userModuleName}/mainCompany`];
    },
    userSelectedLang() {
      return this.$i18n.locale || langTypes.ES;
    },
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
  },
  methods: {
    userHasPermissions() {
      return true;
      // return store.getters[`${modulesName.userModuleName}/hasPermissions`](
      //   permissions
      // );
    },
  },
};
